<app-modal-container
  [bigSize]="false"
  class="modal-expired-session">
  <app-empty-state-standard
    data-qa="modal-expired-session"
    class="w-[25rem] icon-size-8"
    [buttonText]="'Sign in'"
    [isAdmin]="true"
    [icon]="'lock-closed-cylinder.svg'"
    [heading]="'You have been signed out'"
    [description]="'For security reasons, you have been logged out of the Orca system trough all open tabs.'"
    (buttonClick)="goToLogin()"
  />
</app-modal-container>

